import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  AddCard,
  EditCard,
  DeleteCard,
  PurchaseMap,
  CreateUser,
  EditUser,
  ViewUser,
  CreateJob,
  IncidentCreateModal,
  ClientCreate,
} from './index';

class Globals extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Globals';
    }
    render() {
        return (
        	<div>
        		<AddCard />
            <EditCard />
            <DeleteCard />
            <PurchaseMap />
            <EditUser />
            <CreateUser />
            <ViewUser />
            <CreateJob />
            <IncidentCreateModal />
            <ClientCreate modal={true} />
        	</div>
        );
    }
}

export default Globals;



// WEBPACK FOOTER //
// ./src/browser/components/globals.js